import React from "react";
import { Link } from "react-router-dom";
import LfgSection from "./LfgSection";
import PlayersSection from "./PlayersSection";
import PlayerProfilesSection from "./PlayerProfilesSection";
import PricingSection from "./PricingSection";
import AnalyticsSection from "./AnalyticsSection";
import LeaderboardsSection from "./LeaderboardsSection";

const PAGES = {
  lfg: { title: "LFG", emoji: "🆘", Section: LfgSection, needsAuth: true },
  players: { title: "PLAYERS", emoji: "🧑‍🚀", Section: PlayersSection, needsAuth: false },
  profiles: { title: "PROFILES", emoji: "🪪", Section: PlayerProfilesSection, needsAuth: true },
  pricing: { title: "PRICING", emoji: "💸", Section: PricingSection, needsAuth: true },
  analytics: { title: "ANALYTICS", emoji: "📊", Section: AnalyticsSection, needsAuth: false },
  leaderboards: { title: "LEADERBOARDS", emoji: "🏆", Section: LeaderboardsSection, needsAuth: false },
};

export function CategoryPage({ kind, onToast, onRequireAuth, onCompleteProfile, onOpenLeague }) {
  const cfg = PAGES[kind];
  if (!cfg) return null;
  const { title, emoji, Section } = cfg;
  // Every section now optionally accepts toast/auth props — passing them
  // universally is safer than gating on needsAuth.
  return (
    <main className="page-z" data-testid={`category-page-${kind}`}>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 pt-10">
        <Link to="/" data-testid={`${kind}-back-home`} className="inline-flex items-center gap-2 text-xs tracking-widest text-[#a3a3ac] hover:text-[#14b8a6]">
          <i className="fas fa-arrow-left" /> BACK TO ROADMAP
        </Link>
        <h1 className="font-display text-4xl md:text-5xl grad-text mt-4">{emoji} {title}</h1>
      </div>
      <Section
        onToast={onToast}
        onRequireAuth={onRequireAuth}
        onCompleteProfile={onCompleteProfile}
        onOpenLeague={onOpenLeague}
      />
    </main>
  );
}
export default CategoryPage;
